import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import React from "react";
import {useSelector, useDispatch} from 'react-redux';
import * as actionTypes from '../../store/actions/actionTypes';
import axios from "axios";
import apiUrl from "../../shared/config";


export default function AutoLoadToggle({ toggleType = "link", handleCheckboxChange = () => {}, checkboxState = 0}) {
    const userPrefs = useSelector(state => state.auth.userPreferences);
    const token = useSelector(state => state.auth.token) || "";
    const autoLoad = userPrefs && userPrefs.auto_load_game_demos ? +userPrefs.auto_load_game_demos > 0 : 0;
    const dispatch = useDispatch();

    function handleChangeInRedux() {
        const val = autoLoad ? 0 : 1
        updateReduxAndLocalStorage(val);
        // set in database. If it fails we set the redux and local storage back so that the redux will stay in sync with db
        axios.get(apiUrl + "Users/setAutoLoadGames?token=" + token + "&value=" + val)
            .catch(() => updateReduxAndLocalStorage(!autoLoad ? 0 : 1));
    }

    function updateReduxAndLocalStorage(val) {
        dispatch({type: actionTypes.UPDATE_AUTO_LOAD_GAME_EMBEDS, value: val});
        let prefs = localStorage.getItem('user_preferences');
        // check local storage since it is used to set this redux state on login.
        if (prefs) {
            prefs = JSON.parse(prefs);
            prefs.auto_load_game_demos = val;
            localStorage.setItem('user_preferences', JSON.stringify(prefs));
        } else {
            // If preferences don't exist, create a new entry
            const newPrefs = {
                auto_load_game_demos: val
            };
            localStorage.setItem('user_preferences', JSON.stringify(newPrefs));
        }
    }

    const checkBox = <FormControlLabel
        control={
            <Checkbox
                disableRipple
                style={{paddingBottom: 0, paddingTop: 0}}
                checked={(!!checkboxState)}
                onChange={() => {
                    handleCheckboxChange();
                }}
                name="enable_notifications"
                color="primary"
            />
        }
        label="Auto Load Game Demos"
        style={{marginBottom: 0, paddingTop: 5}}
    />

    const link = <span className={'view-game-link'} onClick={handleChangeInRedux}>
        {autoLoad ? "Turn Off Auto Load Games" : "Turn On Auto Load Games"}
    </span>

    let returnJsx = checkBox;

    if (toggleType === "link") {
        returnJsx = link;
    }

    return returnJsx;
}